import { react2angular } from "@pebblepad/react2angular";
import { angularAMD } from "@pebblepad/amd";
import { WithBoundaryBridge } from "@pjs/core-ui";
import { ApprovalSelect } from "@pjs/feedback";

angularAMD.component("approvalSelect", react2angular(WithBoundaryBridge(ApprovalSelect), ["onItemSelect", "options", "labelId", "initialModel", "id"]));
